import { navigationBarConfig } from "config/navigation";
import { NavigationRoute } from "../../types";

export const parsePages = (): NavigationRoute[] => {
  return navigationBarConfig.map(
    ({ children, path, requiredPermission, translationKey, featureFlag }) => {
      const pathValue = path ? { path } : undefined;

      return {
        path: pathValue,
        requiredPermission,
        translationKey,
        featureFlag,
        subroutes: children?.map(({ path, translationKey, requiredPermission, featureFlag }) => ({
          translationKey,
          path: {
            path
          },
          requiredPermission,
          featureFlag
        }))
      };
    }
  );
};
